import $ from '@rover/globals/jquery';

function init() {
    /**
     * Fix jQuery show to work better with Bootstrap hidden/hide classes
     * https://github.com/twbs/bootstrap/issues/9237
     */
    var show = $.fn.show;
    $.fn.show = function() {
        this.removeClass('hidden hide');
        return show.call(this);
    };

    /**
     * Recursively strip whitespace between child elements.
     */
    $.fn.removeWhitespace = function () {
        this.contents().filter(function () {
            if (this.nodeType == 3) {
                return !/\S/.test(this.nodeValue);
            } else {
                $(this).removeWhitespace();
                return false;
            }
        }).remove();
        return this;
    };
}


export default {
    init: init
};



// WEBPACK FOOTER //
// ../utilities/jquery-fixes.js